export default () => ({
  text: 'Preview Text'
})



// WEBPACK FOOTER //
// ./src/shared/components/Text/preview.js